// extracted by mini-css-extract-plugin
export default {"paye-header":"PayeReport_paye-header__+cfGg","divider":"PayeReport_divider__IevP8"};